import React from 'react'
import Modal from 'react-modal'

import './NKModal.css';

function NKModal (props) {

    if (!props.isOpen) {
        return null;
    };
    let className = 'Modal__Bootstrap modal-dialog';
    if (props.size !== null) {
        if (props.size === 'small') {
            className += ' modal-sm';
        }
        if (props.size === 'large') {
            className += ' modal-lg';
        }
        if (props.size === 'xl') {
            className += ' modal-xl ';
        }
    }
    return <Modal shouldCloseOnOverlayClick={false} {...props} contentLabel='' className={className} />;
}

export default NKModal


// WEBPACK FOOTER //
// ./src/felles/Dialogs/NKModal.jsx